/**
 * When an article last changed, as one ISO string.
 *
 * An article is an `ai_messages` row (`project_tasks.artifact_id`). Every revision the writer
 * makes is a NEW row, so the row's `created_at` is when that revision was written. A person's
 * saved edit is made IN PLACE on that row's `tool-generate_document` part and stamps
 * `output.editedAt` (`save_document_markdown`); the row's own `created_at` does not move. The
 * later of the two is the article's last change. `project_tasks.updated_at` is deliberately not
 * used: it also moves on a client's decision or a status write, none of which changes the article.
 */
export function articleChangedAt(
  createdAt: string | null | undefined,
  output: Record<string, unknown> | null | undefined,
): string | null {
  const candidates = [createdAt, typeof output?.editedAt === 'string' ? output.editedAt : null]
    .map((value) => (value ? { value, time: Date.parse(value) } : null))
    .filter(
      (entry): entry is { value: string; time: number } =>
        Boolean(entry) && !Number.isNaN(entry!.time),
    );
  if (candidates.length === 0) return null;
  return candidates.reduce((latest, entry) => (entry.time > latest.time ? entry : latest)).value;
}
